class workingDaysValidator {
  static validate (workingDays) {
    return workingDays.length >= 1
  }
}

export default workingDaysValidator
